import { render, staticRenderFns } from "./NAPAdvisoryManagement.vue?vue&type=template&id=95ee4b38"
import script from "./NAPAdvisoryManagement.vue?vue&type=script&lang=js"
export * from "./NAPAdvisoryManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports